import { h, render } from 'preact';
import './product-component';
import './product-gallery/product-gallery';
import './product-information/product-reviews-count';
import './product-information/product-colors';
import './product-information/product-variant-selector';
import './product-information/product-form';
import './product-information/product-buy-button';
import './product-information/product-back-in-stock-form';
import './product-information/product-promotional-messaging';
import './product-information/product-drop-ship';
import './product-information/size-guide-popup';
import './product-information/review-highlights';
import './product-information/product-matching';
import '../utils/accordion-group';
import ProductMonogramming from './monogram/product-monogramming';
import './product.css';

export default (_, data) => {
  const handleMonogramUpdate = (monogramData, monogramRenderTarget) => {
    const monogramEvent = new CustomEvent('pdp:monogram-update', {
      detail: monogramData,
      bubbles: true,
      composed: true,
    });
    monogramRenderTarget.dispatchEvent(monogramEvent);
  };
  const init = () => {
    const monogramRenderTarget = document.querySelector('product-monogramming');
    render(
      <ProductMonogramming
        product={data.product}
        updateMonogram={(monogramData) =>
          handleMonogramUpdate(monogramData, monogramRenderTarget)
        }
        customizableOptionTag={data.settings.customizableOptionTag}
        images={data.monogramImages}
      />,
      monogramRenderTarget,
    );
  };

  init();
};
